define([
    'jquery',
    'lodash/object/assign',
    'lodash/function/bindAll',
    './components/Twitter',
    'hammerjs',
    'jquery-hammerjs'
], function ($, assign, bindAll, Twitter, Hammer) {
    'use strict';

    var ExhibitionMaterialsPage = function (options) {
        assign(this.options, options);
        this.initialize();
    };

    assign(ExhibitionMaterialsPage.prototype, {
        initialize: function () {

            var $jsSocial = $('.js-social'),
                hashtag = $jsSocial.data('hashtag'),
                proxyUrl = $jsSocial.data('twitter-proxy-url');


            bindAll(this);
            this.$el = $('body');
            this.bindEvents();
            this.origHeroHeight = 0;
            this.heroHeight = 0;
            this.heroLineHeight = parseInt($('.hero-content').css('line-height'), 10);
            this.smallHeroHeight = 300;
            if (this.smallHeroHeight % 20 !== 0) {
                while (this.smallHeroHeight % 20 !== 0) {
                    this.smallHeroHeight += 1;
                }
            }
            this.readMore = false;

            if (hashtag && proxyUrl !== undefined) {
                this.twitter = new Twitter.Twitter({
                    ht: '%23' + hashtag,
                    classAppend: '.jstwitter',
                    proxyUrl: proxyUrl
                });
            }

        },
        bindEvents: function () {
            // Clicking the arrows of the desktop themes navigation
            this.$el.on('click', '.js-themes-nav .js-btn-next', this.clickBtnNextThemeNav);
            this.$el.on('click', '.js-themes-nav .js-btn-prev', this.clickBtnPrevThemeNav);
            // Swiping the desktop version of the themes navigation
            this.$el.find('.js-themes-nav-container').hammer().on('swipe', this.swipeThemesNav);

            // Clicking + touchmobile the mobile version of the themes navigation
            this.$el.on('click', '.js-mobile.js-btn-toggle-themes-nav', this.clickBtnMobileThemesNavToggle);
            this.$el.on('touchmove', '.js-mobile.js-btn-toggle-themes-nav', this.touchMoveBtnToggleThemesNav);

            // Toggling the hero information panel
            this.$el.on('click', '.js-hero .js-toggle-btn', this.clickBtnHeroToggle);
            this.$el.find('.js-hero').hammer().on('swipe', this.swipeHero);

            // Appmodel change
            this.options.appModel.on('change', this.appModelChangedHandler);

            // Clicking on readmore/readless
            this.$el.on('click', '.read-more', this.toggleReadMoreLess);
            this.$el.on('click', '.read-less', this.toggleReadMoreLess);

            //Browser width detection
            $(window).bind('resize', this.widthChangeDetection);
            this.originalScreen = true;
        },

        clickBtnHeroToggle: function (event) {
            this.toggleHero();
        },

        swipeHero: function (event) {
            if (this.options.appModel.get('deviceType') === 'desktop') {
                if(event.gesture.direction & Hammer.DIRECTION_HORIZONTAL) {
                    this.toggleHero(
                        event.gesture.direction === Hammer.DIRECTION_LEFT);
                }
            }
        },

        toggleHero: function (show, animate) {
            var animateTo = {},
                $hero = $('.js-hero'),
                currentlyShown = $hero.data('shown');

            show = show !== undefined ? show : !currentlyShown;
            animate = animate !== undefined ? animate : true;

            if (show !== currentlyShown) {
                animateTo.marginRight = show === true ? 0 : -$hero.outerWidth();

                if (animate) {
                    $hero.animate(animateTo, 150);

                } else {
                    $hero.css(animateTo);
                }

                $hero.find('.js-toggle-btn').toggleClass('inverted-arrow-icon', !show);
                $hero.data('shown', show);
            }
        },

        swipeThemesNav: function (event) {
            if ((event.gesture.direction & Hammer.DIRECTION_HORIZONTAL) &&
                this.options.appModel.get('deviceType') === 'desktop') {

                this.scrollThemeNavigation(
                    event.gesture.direction === Hammer.DIRECTION_LEFT);
            }
        },

        appModelChangedHandler: function () {
            if (this.options.appModel.isChanged('deviceType')) {
                this.deviceTypeChangedHandler();
            }
            if (this.options.appModel.isChanged('mediaQuery')) {
                this.queryChangedHandler();
            }
        },

        deviceTypeChangedHandler: function () {
            var device = this.options.appModel.get('deviceType'),
                firstRun = this.options.appModel.prev('deviceType') === undefined,
                self = this,
                content;
            $('.js-hero .js-toggle-btn').removeClass('inverted-arrow-icon');
            if (device === 'desktop') {
                this.setBackgroundOnElement($('.js-hero').data('background-image-url'), $('.js-hero-background'));
                this.$el.find('.js-hero').removeAttr('style').data('shown', true);
                $('.hero-content > .moreless > *').first().unwrap();
                $('.hero-content .read-more').remove();
                this.readMore = false;
                if (firstRun === false) {
                    $('.js-themes-nav .container, .js-btn-toggle-themes-nav').removeAttr('style');
                    $('.js-btn-toggle-themes-nav').removeClass('active');
                    this.removeBackgroundFromElement($('.js-hero-mobile-background'));
                }
            } else {
                self.originalScreen = true;
                $('.read-less').text('READ MORE');
                $('.read-less').addClass('read-more').removeClass('read-less');
                self.origHeroHeight = $('.hero-content').height();
                self.heroHeight = $('.hero-content').height();
                if (self.heroHeight > self.smallHeroHeight + 50) {
                    content = $('.hero-content').wrapInner('<div class="moreless less">');
                    $('.moreless').after('<a class="mobile read-more" href="javascript:;">Read more</a>');
                    $('.moreless').css('height', self.smallHeroHeight + 'px');
                    this.setBackgroundOnElement($('.js-hero').data('background-image-url'), $('.js-hero-mobile-background'));
                    if (firstRun === false) {
                        this.removeBackgroundFromElement($('.js-hero-background'));
                    }
                }

            }
        },
        queryChangedHandler: function () {
            var query = this.options.appModel.get('mediaQuery'), self = this;
            if (query === 'smallPortrait') {
                if (self.originalScreen === false) {
                    self.heroHeight += 180;
                }
                if (self.readMore ===  true) {
                    $('.moreless').css('height', self.heroHeight + 'px');
                }
                self.originalScreen = false;
            } else {
                if (self.originalScreen === false) {
                    self.heroHeight -= 180;
                }
                if (self.readMore ===  true) {
                    $('.moreless').css('height', self.heroHeight + 'px');
                }
                self.originalScreen = false;
            }
        },
        setBackgroundOnElement: function (backgroundUrl, $el) {
            $el.css('background-image', 'url(' + backgroundUrl + ')');
        },

        removeBackgroundFromElement: function ($el) {
            $el.css('background-image', 'none');
        },

        touchMoveBtnToggleThemesNav: function (event) {
            event.preventDefault();
        },

        clickBtnPrevThemeNav: function (event) {
            this.scrollThemeNavigation(false);
            event.preventDefault();
        },

        clickBtnMobileThemesNavToggle: function (event) {
            this.toggleMobileThemesNavigation();
            event.preventDefault();
        },

        clickBtnNextThemeNav: function (event) {
            this.scrollThemeNavigation(true);
            event.preventDefault();
        },

        scrollThemeNavigation: function (forwards) {
            var movement = $('.js-themes-nav li').outerWidth(true) * 6,
                $themesNavUl = $('.js-themes-nav ul');

            if (forwards === false) {
                movement *= -1;
            }

            $themesNavUl.stop().animate({
                scrollLeft: $themesNavUl.scrollLeft() + movement
            }, 400);
        },

        toggleMobileThemesNavigation: function () {
            var $themesNavContainer = this.$el.find('.js-themes-nav-container'),
                $btnThemesNav = this.$el.find('.js-mobile.js-btn-toggle-themes-nav'),
                currentScrollPosition = this.$el.scrollTop(),
                currentlyShown = $btnThemesNav.hasClass('active'),
                self = this,
                toggle = function () {
                    $btnThemesNav.stop().animate({
                        left: currentlyShown === true ? 0 : $themesNavContainer.outerWidth()
                    }, 'fast');
                    $themesNavContainer.stop().animate({
                        left: currentlyShown === true ? -$themesNavContainer.outerWidth() : 0
                    }, 'fast');

                    self.options.appModel.set('backdropped', !currentlyShown);
                };

            if (this.$el.scrollTop() !== 0) {
                $('body, html').animate({
                    'scrollTop': 0
                }, 150, toggle);
            } else {
                toggle();
            }

            $btnThemesNav.toggleClass('active', !currentlyShown);
        },
        toggleReadMoreLess: function () {
            var self = this;
            if (this.readMore) {
                this.readMore = false;
                $('.read-less').text('READ MORE');
                $('.read-less').addClass('read-more').removeClass('read-less');
                $('.moreless').animate({height: self.smallHeroHeight + 'px'}, 200);
            } else {
                this.readMore = true;
                $('.read-more').text('READ LESS');
                $('.read-more').addClass('read-less').removeClass('read-more');
                $('.moreless').animate({height: self.heroHeight + 'px'}, 200, function() {
                    // Ensure the expanded text is always full height after the
                    // animation (the height is not currently correct if the
                    // page width is resized after load...).
                    $(this).css({height: ''});
                });
            }

        },

        options: {}
    });

    return ExhibitionMaterialsPage;
});



/** WEBPACK FOOTER **
 ** ./js/view/ExhibitionMaterialsPage.js
 **/